/**
 * 金币与人民币换算（与后端 CoinMoneyConstant / App CoinUtils 一致）
 * 用户侧：1 元 = 10000 金币
 * 广告 eCPM 仍为千分位：约 1 元 = 1000（展示广告收入时勿改）
 */
export const COIN_PER_YUAN = 10000
export const ECPM_PER_YUAN = 1000

/** 金币 → 元（保留 2 位，向下截断） */
export function coinsToYuanText(coins) {
  const n = Math.trunc(Number(coins) || 0)
  const sign = n < 0 ? '-' : ''
  const abs = Math.abs(n)
  const intPart = Math.floor(abs / COIN_PER_YUAN)
  const frac = Math.floor((abs % COIN_PER_YUAN) / (COIN_PER_YUAN / 100))
  return sign + intPart + '.' + String(frac).padStart(2, '0')
}

/** 金币 → 元（number，用于图表缩放） */
export function coinsToYuan(coins) {
  return (Number(coins) || 0) / COIN_PER_YUAN
}

/** eCPM 千分位 → 元 */
export function ecpmToYuan(ecpm) {
  return (Number(ecpm) || 0) / ECPM_PER_YUAN
}

/** 元 → eCPM 千分位 */
export function yuanToEcpm(yuan) {
  return Math.round((Number(yuan) || 0) * ECPM_PER_YUAN)
}
